// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "Widgets" + "." + "469c8cda" + ".chunk.css";
};